import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../../../../root-store/login-store/login.selector';
import { DocumentService, UserService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { MxconnectionService } from '@app/shared/services/vault/mxconnection.service';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { FetchAttributeDataSubject } from '../../add-finacial-attribute/attribute-subject.service';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'edit-mx-player',
  templateUrl: './edit-mx-player.component.html',
  styleUrls: ['./edit-mx-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditMxPlayerComponent implements OnInit, OnDestroy {
  @Input() inlineComponent = false;
  @Input() inlineData;
  @Input() hide_checkbox_section = false;

  @Output() actionEvent = new EventEmitter<any>();
  dialogRef;
  myForm = new FormGroup({
    name: new FormControl(false),
  });

  subscription = new Subscription();
  add_mx_data_feed = false;
  currentuserId;
  currentUser;

  templateConfigurationList;
  linkedTemplate = [];
  textBoxPlaceHolder = 'Search or Add New Data Feeds';
  unlinkedTemplate = [];

  currentFormId;
  viewAddedClient = false;
  mxDatList = [];
  formName;
  screenWidth: number;
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  isLoading = true;
  isConnectMXOpen = false;
  mx_connected_clients = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private _store: Store,
    private userService: UserService,
    private dialog: MatDialog,
    private MxconnectionService: MxconnectionService,
    private toastr: ToastrService,
    private injector: Injector,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private mxTaskbarService: MxTaskbarService,
    private attributeSubject: FetchAttributeDataSubject,
    private formBuilder: FormBuilder
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  addUserAccount(item) {
    let fData = { guid: item.guid, vault_user_form_id: this.currentFormId };
    if (item.vault_user_form_id) {
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '400px',
        data: {
          title: `Link ${item.name}?`,
          materialIcon: 'info',
          text: `${item.name} is currently linked to ${item.vaultUserForm.form_name}. Would you like to link it to ${this.formName} instead?`,
          proceedTitle: 'Yes, link it',
          showCancelBtn: true,
        },
      });
      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.getuserData();
            this.addOrUpdateForm(fData, item);
          }
        })
      );
    } else {
      this.addOrUpdateForm(fData, item);
    }
  }
  addOrUpdateForm(fData, item) {
    if (this.mx_connected_clients?.length > 0) {
      try {
        let deleteData = { guid: this.mx_connected_clients[0].guid, vault_user_form_id: null };
        this.subscription.add(
          this.userService.updateUserLinkedForm(deleteData).subscribe((val) => {
            this.subscription.add(
              this.userService.updateUserLinkedForm(fData).subscribe((val) => {
                this.toastr.success('Form linked successfully.');
                this.getuserData();
                this.getLinkedMXAccount();
              })
            );
            this.cd.detectChanges();
          })
        );
      } catch (error) {}
    } else {
      this.subscription.add(
        this.userService.updateUserLinkedForm(fData).subscribe((val) => {
          this.toastr.success('Form linked successfully.');
          this.getuserData();
          this.getLinkedMXAccount();
        })
      );
    }
  }
  isConnectMXOpenEvent(event) {
    this.isConnectMXOpen = event;
  }
  addMxDataEvent(event) {
    if (event) {
      this.isLoading = true;
      this.add_mx_data_feed = false;
      this.getLinkedMXAccount();
    }
  }
  getuserData() {
    this.subscription.add(
      this.MxconnectionService.getUserStatusMX(this.currentuserId).subscribe((res) => {
        this.mxDatList = [];
        let mxDatList = res.mx;

        mxDatList.forEach((element, index) => {
          element.userAccounts.forEach((childElement) => {
            this.mxDatList.push({
              ...childElement,
              form_name: childElement.name,
              profile_image_url: element.institution.medium_logo_url,
            });
          });
        });
        this.isLoading = false;
        this.cd.detectChanges();
      })
    );
  }

  getLinkedMXAccount() {
    this.subscription.add(
      this.MxconnectionService.getLinkedMXAccount(this.currentFormId).subscribe((res) => {
        this.mx_connected_clients = [];
        if (res) this.mx_connected_clients.push(res);
        if (this.mx_connected_clients?.length) {
          this.viewAddedClient = true;
          this.add_mx_data_feed = false;
        }
        this.isLoading = false;
        this.cd.detectChanges();
      })
    );
  }

  addDatafeed(event) {
    this.add_mx_data_feed = true;
    this.addInstitution();
  }
  addInstitution() {
    // this.hidePopUp = true;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        formName: this.formName,
        mx_connected_clients: this.mx_connected_clients,
        title: 'Financial Institution',
        currentFormId: this.currentFormId,
        currentValutUserId: this.currentuserId,
        allowedOne: true,
      },
    });
    this.subscription.add(
      dialogRef.componentInstance.mxDialogMinimized.subscribe((dialogId: string) => {
        this.add_mx_data_feed = false;
        this.cd.detectChanges();
      })
    );
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        this.add_mx_data_feed = false;
        this.getLinkedMXAccount();
        this.cd.detectChanges();
      })
    );
  }

  onChange() {
    // this.dialogRef.close({
    //   markCheck: true,
    // });
  }

  closedialog() {
    this.dialogRef.close({
      markCheck: this.myForm.controls.name.value || this.mx_connected_clients.length > 0,
    });
    this.attributeSubject.handleFetchData(true);
  }
  ngOnInit(): void {
    if (this.inlineComponent) {
      this.data = this.inlineData;
    } else {
      this.dialogRef = this.injector.get(MatDialogRef<EditMxPlayerComponent>);
    }

    this.currentuserId = this.data.currentuserId;

    this.formName = this.data.formName;

    this.currentFormId = this.data.currentFormId;

    this.subscription.add(
      this.documentService.getItemsToSetUpList(this.currentuserId, this.currentFormId).subscribe((res) => {
        let findElement = res.find((x) => x.type == 'api');
        if (findElement) {
          this.myForm.controls.name.setValue(findElement.status == 'created' ? false : true);
        }
      })
    );
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((data) => {
        if (data) {
          this.currentUser = data;
        }
      })
    );

    this.getuserData();
    this.getLinkedMXAccount();

    if (this.inlineComponent) {
      this.subscription.add(
        this.myForm.controls.name.valueChanges.subscribe((val) => {
          this.actionEvent.emit({ status: val == true ? 'complete' : 'created' });
        })
      );
    }
    if (this.data?.hide_checkbox_section) {
      this.hide_checkbox_section = this.data.hide_checkbox_section;
    }
  }

  onToggleChange(event: any): void {
    if (event.checked) {
      this.closedialog();
    }
  }

  removelinkedForm(item) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Remove Link',
        materialIcon: 'delete',
        text: `Are you sure you want to remove this connection?`,
        proceedTitle: 'Remove connection',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          let fData = { guid: item.guid, vault_user_form_id: null };
          this.subscription.add(
            this.userService.updateUserLinkedForm(fData).subscribe((val) => {
              this.toastr.success('Form removed successfully.');
              this.mx_connected_clients = [];
              this.getLinkedMXAccount();
              this.viewAddedClient = false;
              this.getuserData();
              this.cd.detectChanges();
            })
          );
        }
      })
    );
  }
}
